import WebLayout from "../layout/WebLayout";

function Marketing() {
  return (
    <WebLayout pageName={Marketing}>
      <div className="product-dContent__box">
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-description"
            role="tabpanel"
            aria-labelledby="pills-description-tab"
            tabIndex="0"
          >
            <div className="mb-20">
              <h6 className="mb-10">IndianMSME.org Objective:</h6>
              <p className="mb-2">
                The primary goal of IndianMSME.org is to provide a one-stop B2B
                marketplace where manufacturers, including MSMEs across all
                categories, can directly connect with buyers, distributors, and
                wholesalers across India. To strengthen market reach and
                visibility, IndianMSME.org is also establishing 800 Ardh Sainik
                Malls (DDC – Distribution and Display Centres) across 800
                districts. These centers will serve as retail and wholesale hubs
                where MSME manufacturers can showcase their products,
                facilitating both B2B and B2C sales.
              </p>
              <p className="mb-2">
                This marketing plan focuses on brand awareness, digital
                expansion, seller-buyer acquisition, and the physical
                infrastructure of Ardh Sainik Malls (DDCs) to create a
                comprehensive business ecosystem for MSMEs.
              </p>
              <h6 className="mt-10 mb-10">1. Target Audience</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  MSME & Large-Scale Manufacturers – To onboard and encourage
                  product listings.
                </li>
                <li>
                  B2B Buyers – Retailers, wholesalers, bulk buyers,
                  distributors, and corporate clients.
                </li>
                <li>
                  Government & Institutional Buyers – Encouraging procurement
                  from MSMEs.
                </li>
                <li>
                  Logistics & Supply Chain Partners – To ensure smooth delivery
                  operations
                </li>
                <li>
                  Local Retailers & General Public – To facilitate B2C retail
                  opportunities through Ardh Sainik Malls (DDCs).
                </li>
              </ul>
              <h6 className="mt-10 mb-10">2. Branding & Awareness Strategy</h6>
              <ul style={{ listStyle: "upper-alpha", paddingLeft: "20px" }}>
                <li>
                  <strong>Digital Marketing & Online Promotions</strong>
                  <ul className="mt-10">
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          SEO & Content Marketing:
                        </span>
                      </div>
                      <ul className="list-inside mt-10 ms-16">
                        <li className="text-gray-400 mb-4">
                          Optimize the website for search engines with relevant
                          MSME, B2B, and e-commerce keywords.
                        </li>
                        <li className="text-gray-400 mb-4">
                          Publish blogs, case studies, and success stories of
                          MSME sellers.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Social Media Campaigns:
                        </span>
                      </div>
                      <ul className="list-inside mt-10 ms-16">
                        <li className="text-gray-400 mb-4">
                          Leverage platforms like LinkedIn, Facebook, Instagram,
                          and Twitter for brand awareness..
                        </li>
                        <li className="text-gray-400 mb-4">
                          Run targeted ads to attract MSME manufacturers and B2B
                          buyers.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Email Marketing & Newsletters:
                        </span>
                      </div>
                      <ul className="list-inside mt-10 ms-16">
                        <li className="text-gray-400 mb-4">
                          Regular updates on platform features, product
                          listings, and success stories.
                        </li>
                        <li className="text-gray-400 mb-4">
                          Personalized outreach to MSME manufacturers
                          encouraging registration.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Influencer & Community Marketing:
                        </span>
                      </div>
                      <ul className="list-inside mt-10 ms-16">
                        <li className="text-gray-400 mb-4">
                          Collaboration with industry influencers, trade
                          associations, and MSME groups.
                        </li>
                        <li className="text-gray-400 mb-4">
                          Partnering with business forums and chambers of
                          commerce.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          PPC (Pay-Per-Click) & Google Ads:
                        </span>
                      </div>
                      <ul className="list-inside mt-10 ms-16">
                        <li className="text-gray-400 mb-4">
                          Running paid advertisements on Google and social media
                          to attract targeted users.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Offline & Direct Marketing</strong>
                  <ul className="mt-10">
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          MSME & Industry Trade Events:
                        </span>
                      </div>
                      <ul className="list-inside mt-10 ms-16">
                        <li className="text-gray-400 mb-4">
                          Participation in trade expos, industry fairs, and
                          business summits to promote IndianMSME.org.
                        </li>
                        <li className="text-gray-400 mb-4">
                          On-ground marketing with banners, brochures, and live
                          demos.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Ardh Sainik Mall (DDC) Promotions:
                        </span>
                      </div>
                      <ul className="list-inside mt-10 ms-16">
                        <li className="text-gray-400 mb-4">
                          Exclusive branding at 800 Ardh Sainik Malls (DDCs) for
                          MSME product displays.
                        </li>
                        <li className="text-gray-400 mb-4">
                          B2B networking events and live product showcases at
                          each Ardh Sainik Mall.
                        </li>
                        <li className="text-gray-400 mb-4">
                          Engaging with local buyers, retailers, and wholesalers
                          through DDC-based promotions.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Strategic Partnerships with MSME Associations:
                        </span>
                      </div>
                      <ul className="list-inside mt-10 ms-16">
                        <li className="text-gray-400 mb-4">
                          Tie-ups with MSME Development Institutes, NSIC, and
                          Industry Bodies to onboard manufacturers.
                        </li>
                      </ul>
                    </li>
                    <li className="text-gray-400 mb-14 ">
                      <div className="gap-14 flex-align ">
                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Referral & Affiliate Program:
                        </span>
                      </div>
                      <ul className="list-inside mt-10 ms-16">
                        <li className="text-gray-400 mb-4">
                          Reward-based referral system for existing sellers and
                          buyers.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
              <h6 className="mt-10 mb-10">
                3. Seller & Buyer Acquisition Strategy
              </h6>
              <ul style={{ listStyle: "upper-alpha", paddingLeft: "20px" }}>
                <li>
                  Seller Onboarding Drive
                  <ul className="list-inside mt-10 ms-16">
                    <li className="text-gray-400 mb-4">
                      Webinars & Training Sessions on product listing, order
                      management, and payment processing.
                    </li>
                    <li className="text-gray-400 mb-4">
                      Dedicated Abhhyam Marketing Advisors for seller onboarding
                      and assistance.
                    </li>
                    <li className="text-gray-400 mb-4">
                      Special offers for early registrations, such as free
                      listing for the first 6 months.
                    </li>
                  </ul>
                </li>
                <li>
                  Buyer Engagement & Growth
                  <ul className="list-inside mt-10 ms-16">
                    <li className="text-gray-400 mb-4">
                      Exclusive bulk purchase discounts and buyer incentives.
                    </li>
                    <li className="text-gray-400 mb-4">
                      Personalized support for large-scale buyers and
                      institutional procurement.
                    </li>
                    <li className="text-gray-400 mb-4">
                      Regular product showcases at Ardh Sainik Malls (DDCs) and
                      industry-specific catalogs.
                    </li>
                  </ul>
                </li>
              </ul>
              <h6 className="mt-10 mb-10">
                4. Performance Metrics & Analytics
              </h6>
              <ul className="list-inside mt-10 ms-16">
                <li className="text-gray-400 mb-4">
                  Website Traffic & Conversion Rate – Monitor daily visitors and
                  seller registrations.
                </li>
                <li className="text-gray-400 mb-4">
                  Website Traffic & Conversion Rate – Monitor daily visitors and
                  seller registrations.
                </li>
                <li className="text-gray-400 mb-4">
                  Order Volume & Sales Growth – Evaluate B2B transactions and
                  platform success.
                </li>
                <li>
                  Footfall & Retail Sales at Ardh Sainik Malls (DDCs) – Measure
                  offline engagement and sales conversions.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">Conclusion</h6>
              <p className="mb-10">
                With an aggressive online and offline marketing approach,
                IndianMSME.org aims to onboard 20,000+ manufacturers and expand
                to 800 Ardh Sainik Malls (DDCs) across all districts. By
                integrating digital marketing, direct sales, and strategic
                partnerships, the platform will empower Indian MSMEs and
                revolutionize the B2B and B2C supply chain through both online
                and physical retail spaces.
              </p>
              <em>📩 Join IndianMSME.org Today – From Makers to Markets! 🚀</em>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default Marketing;
